import React, { FunctionComponent } from "react";

interface AccordionProps {
  title: string | JSX.Element;
  content: string | JSX.Element;
  accordionId: string;
}

export const Accordion: FunctionComponent<AccordionProps> = ({
  title,
  content,
  accordionId,
}) => {
  return (
    <div className="tab body-txt">
      <input
        type="radio"
        className="accordion-input"
        id={accordionId}
        name={"rd"}
      />
      <label className="tab-label" htmlFor={accordionId}>
        {title}
      </label>
      <div className="tab-content">{content}</div>
    </div>
  );
};
